export default __webpack_public_path__ + "static/media/seamless.9808b1ae.png";